import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from '@/components/layout/Sidebar';
import Header from '@/components/layout/Header';
import { selectSidebarCollapsed } from '@/store/ui/uiSelectors';
import styles from './AppLayout.module.css';

const AppLayout = () => {
  const collapsed = useSelector(selectSidebarCollapsed);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className={styles.layout}>
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div
        className={styles.main}
        style={{
          '--current-sidebar-width': collapsed
            ? 'var(--sidebar-collapsed-width)'
            : 'var(--sidebar-width)',
        }}
      >
        <Header
          mobileOpen={mobileOpen}
          onMobileMenuToggle={() => setMobileOpen((open) => !open)}
        />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppLayout;